export const marketingPageKeys = [
  'about',
  'contact',
  'faq',
  'terms',
  'privacy',
  'cookies',
] as const;
export type MarketingPageKey = (typeof marketingPageKeys)[number];

export type ContentNode =
  | string
  | {
      tag:
        | 'p'
        | 'strong'
        | 'a'
        | 'ul'
        | 'ol'
        | 'li'
        | 'h3'
        | 'table'
        | 'thead'
        | 'tbody'
        | 'tr'
        | 'th'
        | 'td'
        | 'br'
        | 'em';
      children: ContentNode[];
      href?: string;
    };

export type MarketingPageContent = {
  documentTitle: string;
  title: string;
  lede?: string;
  effectiveDate?: string;
  intro: ContentNode[];
  sections: { title: string; body: ContentNode[] }[];
  questions?: { question: string; answer: string }[];
  cta?: { title: string; label: string };
};
